import type { RouteObject } from 'react-router-dom';
import App from './App';
import LoginPage from './features/auth/LoginPage';
import ChatApp from './features/chat/ChatApp';
import LandingPage from './features/landing/LandingPage';
import GraphExplorerPage from './features/graph/GraphExplorerPage';
import OverviewPage from './features/graph/OverviewPage';
import SourceViewPage from './features/sources/SourceViewPage';
import SettingsPage from './features/settings/SettingsPage';
import ProfilePage from './features/profile/ProfilePage';
import AvatarCreatorPage from './features/avatar/AvatarCreatorPage';
import AvatarCollectionPage from './features/gallery/AvatarCollectionPage';
import AvatarDetailPage from './features/gallery/AvatarDetailPage';
import PublicProfilePage from './features/gallery/PublicProfilePage';
import IocDetailPage from './features/ioc/IocDetailPage';
import ActorDetailPage from './features/actor/ActorDetailPage';
import CountryDetailPage from './features/country/CountryDetailPage';
import FamilyDetailPage from './features/family/FamilyDetailPage';
import TechniqueDetailPage from './features/technique/TechniqueDetailPage';
import ExplorePage from './features/explore/ExplorePage';
import TrendsPage from './features/trends/TrendsPage';
import DocsPage from './features/docs/DocsPage';
import FeedbackList from './features/feedback/FeedbackList';

export const routes: RouteObject[] = [
  {
    element: <App />,
    children: [
      { path: '/login', element: <LoginPage /> },
      { path: '/', element: <LandingPage /> },
      { path: '/chat', element: <ChatApp /> },
      { path: '/graph', element: <GraphExplorerPage /> },
      { path: '/overview', element: <OverviewPage /> },
      { path: '/explore', element: <ExplorePage /> },
      { path: '/trends', element: <TrendsPage /> },
      { path: '/trends/:tab', element: <TrendsPage /> },
      { path: '/sources/:citeKey', element: <SourceViewPage /> },
      { path: '/ioc/*', element: <IocDetailPage /> },
      { path: '/actors/:actorName', element: <ActorDetailPage /> },
      { path: '/country/:code', element: <CountryDetailPage /> },
      { path: '/families/:familyName', element: <FamilyDetailPage /> },
      { path: '/techniques/:attackId', element: <TechniqueDetailPage /> },
      { path: '/settings', element: <SettingsPage /> },
      { path: '/profile', element: <ProfilePage /> },
      { path: '/avatar', element: <AvatarCreatorPage /> },
      { path: '/avatars', element: <AvatarCollectionPage /> },
      { path: '/avatars/:id', element: <AvatarDetailPage /> },
      { path: '/users/:key', element: <PublicProfilePage /> },
      { path: '/docs', element: <DocsPage /> },
      { path: '/feedback', element: <FeedbackList /> },
    ],
  },
];
